import React from "react";
import { connect } from "react-redux";
import ParticipantDetailContainerReports from "./ParticipantDetailContainerReports";
import DeleteParticipantButtomDetail from "./DeleteParticipantButtomDetail";
import RecuperarRegistroButtonDetail from "./RecuperarRegistroButtonDetail";
import ModCatGenDetail from "./ModCatGenDetail";
import EditableInput from "../../../../DynamicInput/EditableInput";
import ParticipanStandarData from "./ParticipanStandarData";
import SimpleDialogDemo from "../../../Modals/SimpleDialog";
import UpdateRaceNumber from "./UpdateRaceNumber";
import ValidationAlertButton from "./ValidationAlertButton";
import { validarDorsalEnRango } from "../participantValidationLogic";
import { Button, Typography, Grid, Box, Snackbar } from "@material-ui/core";

class ParticipantDetailContainerView extends React.Component {
  state = {
    openSnackbar: false,
  };

  copyLink = () => {
    const ruta = this.props.registryConfiguration.configuracion.rutaDetalleInscrito;
    const eventoIndex = "evento_" + this.props.eventDetail.iDEvento;

    const rutaCompleta =
      ruta === "https://dashport.run/#/detalle-inscrito/"
        ? "https://dashport.run/detalle-inscrito" +
        "?event=" +
        eventoIndex +
        "&registry=" +
        this.props.ParticipantDetailKey +
        "&download=" +
        true
        : ruta +
        "?event=" +
        eventoIndex +
        "&registry=" +
        this.props.ParticipantDetailKey +
        "&download=" +
        true;

    navigator.clipboard.writeText(rutaCompleta);

    // Abrir Snackbar
    this.setState({ openSnackbar: true });
  };

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  render() {
    const ParticipantDetail =
      (this.props.eventParticipants || {})[this.props.ParticipantDetailKey] || {};

    const numero =
      ParticipantDetail.numero !== undefined ? ParticipantDetail.numero : "No asignado";

    const style = {
      backgroundColor: ParticipantDetail.borrado ? "#CFCFCF" : "white",
    };

    // El dorsal ya asignado, ¿cae dentro del rango de folios definido para
    // la modalidad del atleta? Solo informa, no bloquea.
    const configModalidad =
      this.props.eventSubEventsRegistry &&
      this.props.eventSubEventsRegistry["modalidad_" + ParticipantDetail.modalidad] &&
      this.props.eventSubEventsRegistry["modalidad_" + ParticipantDetail.modalidad].configModalidad;
    const validacionDorsal = validarDorsalEnRango(
      ParticipantDetail.numero,
      configModalidad && configModalidad.folios
    );

    return (
      <Box p={20} style={style} className="overflowTrue">
        <Grid container spacing={2} alignItems="center">
          {/* Columna derecha: borrar */}
          <Grid item xs={6} sm={8}></Grid>
          <Grid item xs={6} sm={4}>
            <Grid container spacing={1} justify="center" alignItems="center">
              <Grid item xs={12} style={{ textAlign: "center" }} id="botonBorrarInscritoCont">
                <DeleteParticipantButtomDetail
                  ParticipantDetail={ParticipantDetail}
                  ParticipantDetailKey={this.props.ParticipantDetailKey}
                  eventDetail={this.props.eventDetail}
                  atleteAccount={this.props.atleteAccount}
                  userID={this.props.userID}
                />
              </Grid>
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <RecuperarRegistroButtonDetail
                  ParticipantDetail={ParticipantDetail}
                  ParticipantDetailKey={this.props.ParticipantDetailKey}
                  eventDetail={this.props.eventDetail}
                  atleteAccount={this.props.atleteAccount}
                  userID={this.props.userID}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Columna izquierda: título, número, interno */}
          <Grid item xs={12} sm={12}>
            <Typography variant="h4" gutterBottom>
              Datos del atleta inscrito
            </Typography>

            <Grid container spacing={2} alignItems="left">
              <Grid item xs={6} sm={2}>
                {(numero > 0 ||
                  (this.props.ParticipantDetail &&
                    this.props.ParticipantDetail.statusPago &&
                    this.props.ParticipantDetail.statusPago.status === "ok")) ? (
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    <SimpleDialogDemo buttonText={"Número " + numero}>
                      <UpdateRaceNumber
                        callback={null}
                        eventIndex={"evento_" + this.props.eventDetail.iDEvento}
                        raceNumber={numero}
                        idRegistro={this.props.ParticipantDetailKey}
                        ParticipantDetail={this.props.ParticipantDetail}
                        eventParticipants={this.props.eventParticipants}
                      />
                    </SimpleDialogDemo>
                    {!validacionDorsal.valido && (
                      <ValidationAlertButton
                        mensaje={validacionDorsal.mensaje}
                        tipo="dorsal"
                      />
                    )}
                  </div>
                ) : (
                  <Typography color="primary" component="h2" variant="subtitle1">
                    Número no asignado
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6} sm={2}>
                <Button variant="outlined" color="primary" onClick={this.copyLink}>
                  Link de registro
                </Button>
              </Grid>
            </Grid>

            <Typography color="primary" component="h2" variant="subtitle1">
              Interno: <b>{this.props.ParticipantDetailKey}</b>
            </Typography>
          </Grid>
        </Grid>

        {/* Datos estándar del participante */}
        <Box mt={4}>
          <ParticipanStandarData
            ParticipantDetail={ParticipantDetail}
            eventDetail={this.props.eventDetail}
            userID={this.props.userID}
            atleteAccount={this.props.atleteAccount}
            ParticipantDetailKey={this.props.ParticipantDetailKey}
            registryConfiguration={this.props.registryConfiguration}
          />
        </Box>

        {/* ModCatGen en su propia fila */}
        <Box mt={2} id="ModCatGenDivCont">
          <Grid container>
            <Grid item xs={12}>
              <ModCatGenDetail
                ParticipantDetail={ParticipantDetail}
                ParticipantDetailKey={this.props.ParticipantDetailKey}
                eventDetail={this.props.eventDetail}
                eventSubEventsRegistry={this.props.eventSubEventsRegistry}
                registryAutorizedUsers={this.props.registryAutorizedUsers}
                registryConfiguration={this.props.registryConfiguration}
                userID={this.props.userID}
                atleteAccount={this.props.atleteAccount}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Reports */}
        <Box mt={2}>
          <ParticipantDetailContainerReports
            ParticipantDetail={ParticipantDetail}
            ParticipantDetailKey={this.props.ParticipantDetailKey}
            eventDetail={this.props.eventDetail}
            eventSubEventsRegistry={this.props.eventSubEventsRegistry}
            registryConfiguration={this.props.registryConfiguration}
            registryAutorizedUsers={this.props.registryAutorizedUsers}
            userID={this.props.userID}
            atleteAccount={this.props.atleteAccount}
          />
        </Box>

        {/* Snackbar de confirmación */}
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={this.state.openSnackbar}
          autoHideDuration={3000}
          onClose={this.handleCloseSnackbar}
          message="¡Link copiado al portapapeles!"
        />
      </Box>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

const mapStateToProps = (state) => {
  return {
    eventDetail: state.events.eventDetail,
    eventParticipants: state.registry.eventParticipants,
    registryConfiguration: state.registry.registryConfiguration,
    registryAutorizedUsers: state.registry.registryAutorizedUsers,
    eventSubEventsRegistry: state.events.eventSubEventsRegistry,
    eventSubEventsRegistrySnap: state.events.eventSubEventsRegistrySnap,
    userID: state.atlete.userID,
    atleteAccount: state.atlete.atleteAccount,
  };
};

const ParticipantDetailContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ParticipantDetailContainerView);

export default ParticipantDetailContainer;
